var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_442_4856)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7755 23.751H9.51016V13.2358H12.7755V23.751ZM11.1411 11.8014C10.0969 11.8014 9.25 10.9365 9.25 9.8924C9.25 9.39086 9.44924 8.90986 9.80388 8.55522C10.1585 8.20058 10.6395 8.00134 11.1411 8.00134C11.6426 8.00134 12.1236 8.20058 12.4782 8.55522C12.8329 8.90986 13.0321 9.39086 13.0321 9.8924C13.0321 10.9365 12.1848 11.8014 11.1411 11.8014ZM24.9965 23.751H21.7382V18.6322C21.7382 17.4123 21.7136 15.8479 20.0405 15.8479C18.3428 15.8479 18.0827 17.1733 18.0827 18.5444V23.751H14.8209V13.2358H17.9526V14.6701H17.9983C18.4342 13.844 19.4991 12.9721 21.0878 12.9721C24.3925 12.9721 25 15.1483 25 17.9748V23.751H24.9965Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.25 17C34.25 26.3888 26.6388 34 17.25 34C7.86116 34 0.25 26.3888 0.25 17C0.25 7.61116 7.86116 0 17.25 0C26.6388 0 34.25 7.61116 34.25 17ZM1.1 17C1.1 25.9194 8.3306 33.15 17.25 33.15C26.1694 33.15 33.4 25.9194 33.4 17C33.4 8.0806 26.1694 0.85 17.25 0.85C8.3306 0.85 1.1 8.0806 1.1 17Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_442_4856"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.75,
    height: 18,
    fill: "white",
    transform: "translate(9.25 8)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.f49007d4ef3a26b49a1b72c59cc38eea.svg";
export { ForwardRef as ReactComponent };